import { parseDocument } from 'htmlparser2';
import { domToReact, type DOMNode } from 'html-react-parser';

// Parses an SVG string into React elements.
export function parseSvg(svg: string) {
  const doc = parseDocument(svg, {
    xmlMode: true,
    lowerCaseAttributeNames: false,
  });
  return domToReact(doc.children as Array<DOMNode>);
}
